import React from "react";
import {
  List,
  Datagrid,
  SimpleList,
  TextField,
  DateField,
  NumberField,
  FunctionField,
  ReferenceField,
} from "react-admin";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  useMediaQuery,
} from "@mui/material";

export const RecentTransactions = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <React.Fragment>
      <Card
        variant="outlined"
        sx={{
          mt: 2,
          backgroundColor: "#242424",
          borderRadius: "8px",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            component="div"
            sx={{ fontSize: 22, fontWeight: 500, color: "#FFF" }}
          >
            Recent Transactions
          </Typography>
        </CardContent>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            position: "relative",
            height: "330px",
          }}
        >
          <List
            actions={null}
            pagination={false}
            sx={{ padding: "20px", background: "#242424", boxShadow: "none" }}
          >
            <div
              style={{
                width: "100%",
                overflowX: "auto",
                overflowY: "hidden", // Prevent vertical scrolling
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
              }}
            >
              <Datagrid bulkActionButtons={false} sx={{ overflowX: "auto" }}>
                <DateField source="txn_datetime" label="Date" />
                <NumberField
                  textAlign="left"
                  source="amount"
                  label="Amount"
                />
                <ReferenceField
                  source="user.id"
                  reference="users"
                  label="User"
                  emptyText="Missing User"
                  link={false}
                  sortBy="user.username"
                >
                  <TextField source="username" />
                </ReferenceField>
                <FunctionField
                  label="Type"
                  source="txn_type"
                  render={(record) => {
                    const getColor = (status) => {
                      switch (status) {
                        case 0:
                          return "success";
                        case 1:
                          return "error";
                        default:
                          return "default";
                      }
                    };
                    const statusMessage = {
                      0: "Recharge",
                      1: "Redeem",
                    }[record.txn_type];
                    return (
                      <Chip
                        label={statusMessage}
                        color={getColor(record?.txn_type)}
                        size="small"
                      />
                    );
                  }}
                />
              </Datagrid>
            </div>
          </List>
        </div>
      </Card>
    </React.Fragment>
  );
};
